import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
const normalizePhone = require('../../../utils/normalizePhone').handler;

const required = value => value ? undefined : 'Required';
const requiredNumber = value => !value && value !== 0 ? 'Required' : undefined;

const filterMonth = ({ value, label }, search) => {
  const l = (label || '').trim().toLowerCase();
  const compare = (search || '').toLowerCase();
  if ((l || '').startsWith(compare)) return true;
  if (isNaN(search)) return false;
  try {
    const num = parseInt(search);
    return num === value + 1;
  } catch (err) {
    return false;
  }
};

const passwordMatch = (...props) => {
  const { password, password2 } = props[1] || {};

  return password !== password2 ? 'Passwords do not match.' : undefined;
};

const passwordLength = (...props) => {
  const { password } = props[1] || {};
  return password.length < 8
    ? 'Password must be at least 8 characters long.'
    : undefined;
};

const checkIsDuplicate = error => {
  const { jsonData } = error || {};
  const { json } = jsonData || {};
  const { duplicate } = json || {};
  return duplicate;
};

const SignUpForm = (
  {
    handleSubmit,
    submitting,
    signupError,
    lookups,
    searchAddress,
    getAddressSuggestionsResult,
    handleGetAddressSuggestions,
    change,
    handleSelect,
    searchValue
  }
) => {

  const handleSelectSuggestedAddress = (e, value) => {
    const { city, street_line, secondary, state, zipcode } = value || {};
    handleSelect({ address1: street_line, searchAddress: false })
    change('address1', street_line);
    change('address2', secondary);
    change('city', city);
    change('stateId', getStateId(state));
    change('zip', zipcode);
    change('stateShort', state);
    change('countryId', 37);
  };
  const {
    states
  } = lookups || {};
  const stateOptions = (states || [])
    .filter(({ countryId }) => countryId === 37)
    .map(({ stateId, stateName }) => ({
      value: stateId,
      label: stateName
    }));
  const isDuplicate = checkIsDuplicate(signupError);

  const getStateId = (state) => {
    const stateObj = states.find(stateItem => stateItem.stateShort === state);
    return stateObj ? stateObj.stateId : null;;
  }
  const { suggestions } = getAddressSuggestionsResult || {};
  const suggestedOptions = (suggestions || []).map(a => ({
    value: a,
    label: a.secondary ? `${a.street_line} ${a.secondary}, ${a.city} ${a.state} ${a.zipcode} ` : `${a.street_line}, ${a.city} ${a.state} ${a.zipcode} `
  }))

  const handleBlur = () => {
    if (searchAddress) {
      change('address1', searchValue);
      handleSelect({ searchAddress: false })
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <Field
            name="email"
            type="text"
            component={FormField.Input}
            placeholder="Email Address"
            validate={[required]}
          />
          <Field
            name="name_first"
            type="text"
            component={FormField.Input}
            placeholder="First Name"
            validate={[required]}
          />
          <Field
            name="name_last"
            type="text"
            component={FormField.Input}
            placeholder="Last Name"
            validate={[required]}
          />
          <div className="form-row">
            <div className="col-6">
              <Field
                name="dob_month"
                type="text"
                component={FormField.SelectReact}
                placeholder="Birth Month"
                validate={[requiredNumber]}
                filterOption={filterMonth}
                options={[
                  { value: 0, label: 'January' },
                  { value: 1, label: 'February' },
                  { value: 2, label: 'March' },
                  { value: 3, label: 'April' },
                  { value: 4, label: 'May' },
                  { value: 5, label: 'June' },
                  { value: 6, label: 'July' },
                  { value: 7, label: 'August' },
                  { value: 8, label: 'September' },
                  { value: 9, label: 'October' },
                  { value: 10, label: 'November' },
                  { value: 11, label: 'December' }
                ]}
              />
            </div>
            <div className="col-3">
              <Field
                name="dob_day"
                type="text"
                component={FormField.SelectReact}
                placeholder="Day"
                validate={[required]}
                options={Array.from(Array(31), (_, i) => ({
                  value: i + 1,
                  label: i + 1
                }))}
              />
            </div>
            <div className="col-3">
              <Field
                name="dob_year"
                type="text"
                component={FormField.SelectReact}
                placeholder="Year"
                validate={[required]}
                options={Array.from(Array(90), (_, i) => ({
                  value: new Date().getFullYear() - 21 - i,
                  label: new Date().getFullYear() - 21 - i
                }))}
              />
            </div>
          </div>
          <Field
            name="password"
            type="password"
            component={FormField.Input}
            placeholder="Enter Password"
            validate={[required]}
          />
          <Field
            name="password2"
            type="password"
            component={FormField.Input}
            placeholder="Re-Enter Password"
            validate={[required, passwordMatch, passwordLength]}
          />
        </div>
        <div className="col-md-6">


          {!searchAddress &&
            <Field
              name="address1"
              component={FormField.Input}
              type="text"
              label="Address"
              onChange={(e) => {
                if (e.target.value.length < 3) {
                  handleSelect({ address1: '', searchAddress: true })
                }
              }}
            />
          }
          {searchAddress &&
            <Field
              name="selectedFromAutoComplete"
              type="text"
              component={FormField.SelectReact}
              label="Address"
              onInputChange={(newValue) => {
                handleGetAddressSuggestions(newValue);

              }}
              onBlur={(e, input) => handleBlur(e, input)}
              options={suggestedOptions}
              onChange={handleSelectSuggestedAddress}
            />
          }
          <div className="form-row">
            <div className="col-md-4">
              <Field
                name="address2"
                type="text"
                component={FormField.Input}
                placeholder="Apt/Suite"
                validate={[]}
              />
            </div>
            <div className="col-md-8">
              <Field
                name="city"
                type="text"
                component={FormField.Input}
                placeholder="City"
                validate={[required]}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-6">
              <Field
                name="stateId"
                type="text"
                component={FormField.SelectReact}
                placeholder="State"
                validate={[required]}
                options={stateOptions}
              />
            </div>
            <div className="col-md-6">
              <Field
                name="zip"
                type="text"
                component={FormField.Input}
                placeholder="Zip"
                validate={[required]}
              />
            </div>
          </div>
          <Field
            name="phone"
            type="text"
            component={FormField.Input}
            placeholder="Contact Phone Number"
            validate={[required]}
            normalizeOnBlur={normalizePhone()}
          />
          <Field
            name="mobilePhone"
            type="text"
            component={FormField.Input}
            placeholder="Mobile Phone (optional)"
            normalizeOnBlur={normalizePhone()}
          />
          <div className="form-group checkbox-group">

            <Field
              name="smsMarketingTW"
              type="checkbox"
              component={FormField.InlineCheckbox}
              label="Text me with news and offers"
              normalize={value => !!value}
            />
            <Field
              name="smsTransactional"
              type="checkbox"
              component={FormField.InlineCheckbox}
              label="Text me with order updates"
              normalize={value => !!value}
            />
          </div>
          <div className="form-group checkbox-group">
            <legend>Email Preferences:</legend>
            <Field
              name="IsDiscoveringTwomey"
              label="Special Offers and News"
              type="checkbox"
              component={FormField.InlineCheckbox}
              normalize={value => !!value}
            />
            <Field
              name="IsDiscoveringSilveroak"
              label="Silver Oak Wines"
              type="checkbox"
              component={FormField.InlineCheckbox}
              normalize={value => !!value}
            />
            <Field
              name="IsWineEducation"
              label="Cabernet Life – Wine and Food Education"
              type="checkbox"
              component={FormField.InlineCheckbox}
              normalize={value => !!value}
            />
          </div>
        </div>
      </div>
      <button type="submit" className="btn btn-primary" disabled={submitting}>
        Create Account
      </button>
      {signupError &&
        !isDuplicate &&
        <span style={{ color: '#dc3545', marginLeft: '20px' }}>
          An error occurred during signup
        </span>}
      {isDuplicate &&
        <span style={{ color: '#dc3545', marginLeft: '20px' }}>
          Email already exists!
        </span>}
    </form>
  );
};

export default reduxForm({
  form: 'sign-up-form'
})(SignUpForm);

